import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { JoinCooperativeView } from './JoinCooperativePage';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PublicLandingDraftPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/public/landing/draft/${token}`)
      .then((r) => setData(r.data))
      .catch((e) => setError(e?.response?.data?.detail || 'Lien invalide ou expiré'));
  }, [token]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F8F5] p-6">
        <div className="text-center max-w-md">
          <p className="text-[#EA3C3A] font-semibold">Aperçu indisponible</p>
          <p className="text-sm text-[#5E6D66] mt-2">{error}</p>
        </div>
      </div>
    );
  }
  if (!data) {
    return <div className="min-h-screen flex items-center justify-center bg-[#F9F8F5]"><p className="text-[#5E6D66]">Chargement…</p></div>;
  }
  return (
    <div>
      <div className="sticky top-0 z-50 bg-[#FF8E00] text-white text-xs font-semibold px-4 py-2 text-center" data-testid="draft-banner">
        Aperçu brouillon — Non publié · Ce lien expire dans 14 jours
      </div>
      <JoinCooperativeView data={data} />
    </div>
  );
}
